import { JSX } from "react";
import apiClient from "../apiClient";

const baseUrl = '/system/menus'

export type MenuStatus = 'enabled' | 'disabled';

export type MenuItem = {
    _id: string;
    name: string;
    path: string;
    component?: string;
    layout?: boolean;
    icon?: JSX.Element;
    order?: number;
    description?: string;
    status: MenuStatus;
    createdAt?: string;
    updatedAt?: string;
};

export async function getMenus(params: Record<string, any> = {}) {
    return apiClient<{
        list: MenuItem[]; total: number;
    }>(baseUrl, {
        method: 'GET',
        params,
    });
}

export async function addMenu(data: Partial<MenuItem>) {
    return apiClient(baseUrl, {
        method: 'POST',
        data,
    });
}

export async function updateMenu(id: string, data: Partial<MenuItem>) {
    return apiClient(`${baseUrl}/${id}`, {
        method: 'PUT',
        data,
    });
}

export async function deleteMenu(id: string) {
    return apiClient(`${baseUrl}/${id}`, {
        method: 'DELETE',
    });
}


/** 除了该role 以外所有的菜单 */
export async function getMenusExcludeRole(params: {
    roleCode?: string;
}) {
    return apiClient<{
        list: MenuItem[]; total: number;
    }>(`${baseUrl}/role`, {
        method: 'GET',
        params,
    });
}
